import cloneDeep from 'lodash/cloneDeep';
import {
  SET_PASSPORT_DATA,
  CHANGE_PASSPORT_DATA,
  CHANGE_DOCUMENT_TYPE,
  BLUR_PASSPORT_DATA,
  LOAD_DRAFT_EMPTY
} from '../constants';

import { getCitizenshipByDocumentType } from '../../helpers/citizenship';

const initialState = {
  documents: [],
  data: {},
  firstState: null,
  firstCitizenship: '',
  editableFields: {},
  disabled: false,
  blur: {}
};

const passport = (state = initialState, action) => {
  switch (action.type) {
    case SET_PASSPORT_DATA:
      const { citizenship, data } = action.payload;

      if (citizenship) {
        if (state.firstState[citizenship]) {
          return {
            ...state.firstState[citizenship],
            firstState: cloneDeep(state.firstState)
          };
        }

        return {
          ...initialState,
          firstState: cloneDeep(state.firstState)
        };
      }

      const firstCitizenship = getCitizenshipByDocumentType(data.documentType);
      const firstState = firstCitizenship
        ? {
            [firstCitizenship.name]: cloneDeep(action.payload)
          }
        : null;

      return {
        ...state,
        ...action.payload,
        firstState,
        firstCitizenship,
        blur: {}
      };
    case CHANGE_DOCUMENT_TYPE:
      const russianCitizenFirstState = state.firstState['Гражданин РФ'];
      const isDataFromLK = russianCitizenFirstState?.disabled;
      const { documentType } = action.payload.data;
      if (documentType === 'PASSPORT_RF' && isDataFromLK) {
        return {
          ...state,
          ...(russianCitizenFirstState || {}),
          documents: [],
          blur: {}
        };
      }

      return {
        ...state,
        ...action.payload,
        blur: {}
      };
    case BLUR_PASSPORT_DATA:
      return {
        ...state,
        blur: {
          ...state.blur,
          [action.payload]: true
        }
      };
    case CHANGE_PASSPORT_DATA:
      return {
        ...state,
        data: {
          ...state.data,
          ...action.payload.data
        },
        blur: {
          ...state.blur,
          [action.payload.field]: false
        }
      };
    case LOAD_DRAFT_EMPTY:
      if (!state.firstState && !state.firstCitizenship?.name) {
        return {
          ...initialState
        };
      }

      return {
        ...initialState,
        ...state.firstState[state.firstCitizenship.name],
        firstState: {
          [state.firstCitizenship.name]: {
            ...state.firstState[state.firstCitizenship.name]
          }
        },
        firstCitizenship: state.firstCitizenship
      };
    default:
      return state;
  }
};

export default passport;
